import { render, staticRenderFns } from "./WDPopCommissions.vue?vue&type=template&id=25457c72&"
import script from "./WDPopCommissions.vue?vue&type=script&lang=js&"
export * from "./WDPopCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports